import { Show, onMount } from 'solid-js'
import { useNavigate } from '@solidjs/router'
import { useAuth } from '../lib/auth'

function isVenueDomain(): boolean {
  if (typeof window === 'undefined') return false
  return window.location.hostname === 'venue.zipcheck.my'
}

export default function Home() {
  const navigate = useNavigate()
  const auth = useAuth()

  // Redirect to venue login if on venue domain
  onMount(() => {
    if (isVenueDomain()) {
      navigate('/venue-login', { replace: true })
    }
  })

  return (
    <div class="min-h-dvh bg-gray-50 flex flex-col">
      <header class="bg-white border-b border-gray-200 px-4 py-3">
        <div class="max-w-md mx-auto flex items-center gap-2">
          <img src="/logo.svg" alt="ZipCheck" class="h-8" />
          <span class="text-lg font-semibold text-gray-900">ZipCheck</span>
        </div>
      </header>

      <main class="flex-1 flex items-center justify-center p-4">
        <div class="w-full max-w-md text-center">
          <Show
            when={auth.isAuthenticated()}
            fallback={
              <>
                <div class="mb-8">
                  <div class="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span class="text-4xl">🪪</span>
                  </div>
                  <h1 class="text-2xl font-bold text-gray-900 mb-2">Your digital wardrobe pass</h1>
                  <p class="text-gray-600">
                    Check in your items at any venue in seconds. No app download needed.
                  </p>
                </div>

                <div class="space-y-3">
                  <button
                    onClick={() => navigate('/signup')}
                    class="w-full py-3 px-4 bg-emerald-600 text-white font-semibold rounded-lg
                           hover:bg-emerald-700 active:bg-emerald-800 transition-colors"
                  >
                    Get started
                  </button>
                  <button
                    onClick={() => navigate('/venue-login')}
                    class="w-full py-3 px-4 bg-white text-gray-700 font-medium rounded-lg
                           border border-gray-300 hover:bg-gray-50 transition-colors"
                  >
                    Venue login
                  </button>
                </div>
              </>
            }
          >
            {/* Authenticated — redirect to pass */}
            {(() => {
              navigate('/pass', { replace: true })
              return null
            })()}
          </Show>
        </div>
      </main>
    </div>
  )
}
